export default "__VITE_ASSET__f0d15804__"